import React from 'react/addons';
import {FluxMixin} from 'fluxxor';
import OnClickOutsideMixin from 'react-onclickoutside';
import cx from 'classnames';
import breakpoints from 'ofs/breakpoints';
import RawTether from 'ofs/react/RawTether';


var Tooltip = React.createClass({
  mixins: [
    FluxMixin(React),
    OnClickOutsideMixin
  ],

  getDefaultProps() {
    return {
      panelAttachment: 'top center',
      targetAttachment: 'bottom center'
    };
  },

  getInitialState() {
    return {
      panelStyle: {},
      anchorStyle: {},
      panelClasses: [],
      anchorClasses: []
    };
  },

  close() {
    this.getFlux().actions.layers.remove(this);
  },

  handleClickOutside() {
    this.close();
  },

  getAnchorOptions() {
    return {
      element: this.refs.anchor.getDOMNode(),
      target: this.props.attachTo,
      attachment: this.props.panelAttachment,
      targetAttachment: this.props.targetAttachment,
      offset: '0 0',
      onPosition: this.onAnchorPosition,
    };
  },

  getPanelOptions() {
    return {
      element: this.refs.panel.getDOMNode(),
      target: this.props.attachTo,
      offset: '0 0',
      onPosition: this.onPanelPosition,
      attachment: this.props.panelAttachment,
      targetAttachment: this.props.targetAttachment
    };
  },

  onResize() {
    if (this._panelTether) {
      this._panelTether.setOptions(this.getPanelOptions());
    }
  },

  componentDidMount() {
    this._panelTether = new RawTether(this.getPanelOptions());
    this._anchorTether = new RawTether(this.getAnchorOptions());
    this._panelTether.enable();
    this._anchorTether.enable();

    window.addEventListener('resize', this.onResize);
  },

  onPanelPosition(position, elementClasses) {
    var panelStyle = {
      top: position.page.top,
      left: this.calculateLeft(position.page.left)
    };
    var panelClasses = elementClasses;
    this.setState({panelStyle, panelClasses});
  },

  calculateCenter() {
    return (window.outerWidth - React.findDOMNode(this.refs.panel).offsetWidth) / 2;
  },

  isScreenTiny() {
    return window.outerWidth <= breakpoints.tiny;
  },

  hasBreathingRoom() {
    return window.outerWidth - React.findDOMNode(this.refs.panel).offsetWidth > 20;
  },

  calculateLeft(defaultValue) {
    if (this.isScreenTiny()) {
      return this.calculateCenter();
    // the tooltip might want to be partially cut off. lets fix that here.
    } else if (defaultValue < 0) {
      // if there is "lots" of room available then use a small hardcoded value.
      // We use this hardcoded value instead of centering the panel to prevent
      // the panel and the anchor becoming detached - which can happen with
      // larger screens.
      if (this.hasBreathingRoom()) {
        return 10;
      } else {
        return this.calculateCenter();
      }
    } else {
      return defaultValue;
    }
  },

  onAnchorPosition(position, elementClasses) {
    var anchorStyle = {
      top: position.page.top,
      left: position.page.left
    };
    var anchorClasses = elementClasses;
    this.setState({anchorStyle, anchorClasses});
  },


  componentWillUnmount() {
    if (this._panelTether) {
      this._panelTether.disable();
    }
    if (this._anchorTether) {
      this._anchorTether.disable();
    }
    window.removeEventListener('resize', this.onResize);
  },

  render() {
    var panelClasses = this.state.panelClasses.map(c => 'ofs-Tooltip__Panel--' + c);
    var anchorClasses = this.state.anchorClasses.map(c => 'ofs-Tooltip__Anchor--' + c);

    panelClasses.unshift('ofs-Tooltip__Panel');
    anchorClasses.unshift('ofs-Tooltip__Anchor');
    return (
      <div className="ofs-Tooltip">
        <div ref="panel" className={cx.apply(this, panelClasses)} style={this.state.panelStyle}>
          {this.props.children}
        </div>
        <div ref="anchor" className={cx.apply(this, anchorClasses)} style={this.state.anchorStyle} />
      </div>
    );
  }
});

export default Tooltip;



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/components/layers/Tooltip.jsx
 **/